import { Header } from '@/components/Header'
import { PoweredByParkeze } from '@/components/PoweredByParkeze'
import { activeOrg, apiBase } from '@/services/api'
import { ModuleHost } from '@/shell/ModuleHost'
import { Announcements } from '@/shell/Announcements'
import { getRealmFromSession } from '@/hooks/useBranding'

/**
 * /home: the reservations calendar is the `reservation-app` module's calendar
 * view from modules.parkeze.com (logbook decision 32), under the site's own
 * header -- the same calendar the dashboard's Reservations page mounts.
 *
 * The site has no page per reservation, so it leaves `open-reservation` alone
 * and the record opens over the calendar. Booking happens inside the module
 * too; each visit mounts it afresh, so it always reads the bookings anew.
 */
export default function HomePage() {
  return (
    <div className="h-dvh bg-background flex flex-col overflow-hidden">
      <Header />
      <Announcements operator={getRealmFromSession()} />
      <main className="flex-1 min-h-0" aria-label="Reservations home">
        <ModuleHost
          id="reservation-app"
          major={1}
          label="reservations calendar"
          attributes={{
            view: 'calendar',
            'api-base': apiBase(),
            'active-org': activeOrg(),
          }}
        />
      </main>
      <PoweredByParkeze />
    </div>
  )
}
